<!--
 * @Description: 上传头像、logo、icon等
 * @Author: 琢磨先生
 * @Date: 2022-05-13 15:47:15
 * @LastEditors: 琢磨先生
 * @LastEditTime: 2022-06-17 17:10:25
-->
<!-- 
<template>
  <el-upload
    class="avatar-uploader"
    action=""
    :show-file-list="false"
    :http-request="upload"
    :on-success="handleAvatarSuccess"
    :before-upload="beforeAvatarUpload"
  >
    <img v-if="imageUrl" :src="imageUrl" class="avatar" />
    <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
  </el-upload>
</template>

<script>
import ObsClient from "../../obs/esdk-obs-browserjs.3.22.3.min.js";
import img_utils from "@/utils/img_utils";

export default {
  data() {
    return {
      loading: false,
      imageUrl: null,
    };
  },
  emits: ["change"],
  props: ["url", "change", "hook"],
  watch: {
    url: {
      handler(val) {
        this.imageUrl = val;
      },
      immediate: true,
    },
  },
  created() {
    var settings = this.$store.getters.getSettings;
    this.bucketName = settings.obs_bucket_name;
    this.obs_cdn = settings.obs_cdn;
    this.obs = new ObsClient({
      access_key_id: settings.obs_key_id,
      secret_access_key: settings.obs_access_key,
      server: settings.obs_server,
      timeout: 60 * 5,
    });
  },
  methods: {
    /**
     * 执行上传
     */
    upload: async function (ctx) {
      ctx.onProgress({ percent: 0 });

      // this.loading = true;

      var _f = ctx.file;
      //大于2M进行图片压缩
      if (ctx.file.size > 1024 * 1024 * 2) {
        _f = await img_utils.compress(ctx.file);
        _f.name = ctx.file.name;
      }

      var ext = `.${ctx.file.type.replace("image/", "")}`;
      this.$http.get("/common/filename").then(async (res) => {
        if (res.code == 0) {
          var result = await this.obs.putObject({
            Bucket: this.bucketName,
            Key: res.data + ext,
            SourceFile: ctx.file,
          });
          if (result.CommonMsg.Status < 300) {
            this.loading = false;
            this.imageUrl = `${this.obs_cdn}/${res.data}${ext}`;
            if (typeof this.change == "function") {
              this.change(this.imageUrl, this.hook);
              this.$emit("change", this.imageUrl, this.hook);
            }
          }
        }
      });
    },
    /**
     * 上传成功
     */
    handleAvatarSuccess(res) {
      console.log(res);
    },
    /**
     * 上传前
     */
    beforeAvatarUpload() {},
  },
};
</script>


<style scoped>
.avatar-uploader .avatar {
  width: 120px;
  height: 120px;
  display: block;
}
</style>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
  border-color: var(--el-color-primary);
}

.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  text-align: center;
}
</style> -->


<template>
  <!-- <div class="btn_upload" @click="dialogVisible = true">
    <el-icon class="upload-icon"><Upload /></el-icon>
    <div class="text">上传图片</div>
  </div> -->
  <el-upload
    class="avatar-uploader"
    action=""
    :show-file-list="false"
    :http-request="upload"
    accept=".jpg,.jpeg,.png,.gif"
    :before-upload="beforeAvatarUpload"
  >
    <!-- <img v-if="imageUrl" :src="imageUrl" class="avatar" /> -->
    <el-image
      v-if="imageUrl"
      :src="imageUrl"
      class="avatar"
      fit="scale-down"
    ></el-image>
    <el-icon v-else class="avatar-uploader-icon"><Upload /></el-icon>
    <div class="progress" v-if="saving">
      <el-progress type="circle" :width="90" :percentage="percentage" />
    </div>
  </el-upload>

  <el-dialog
    title="剪裁图片"
    v-model="visibleCropper"
    width="460px"
    :append-to-body="true"
    draggable
    :destroy-on-close="true"
  >
    <vue-cropper
      ref="cropper"
      :viewMode="1"
      :zoomable="false"
      :src="cropperBase64"
      :autoCropArea="1"
      :rotatable="false"
      :scalable="false"
      :minContainerHeight="400"
      :aspectRatio="aspectRatio"
      alt="Source Image"
    >
    </vue-cropper>
    <template #footer>
      <el-button type="primary" @click="handleCropper">确定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import ObsClient from "../../obs/esdk-obs-browserjs.3.22.3.min.js";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import img_utils from "@/utils/img_utils";
import md5_util from "@/utils/md5_util.js";

export default {
  components: {
    VueCropper,
  },
  data() {
    return {
      imageUrl: null,
      saving: false,
      visibleCropper: false,
      //需要剪裁的图片base64格式
      cropperBase64: "",
      //进度条
      percentage: 0,
    };
  },
  emits: ["close", "change"],
  props: ["folder", "aspectRatio", "hook", "src"],
  watch: {
    src: {
      handler() {
        //原始图片地址
        if (this.src != this.cdn_url) {
          this.imageUrl = this.src;
        }
      },
      immediate: true,
    },
  },
  created() {
    var settings = this.$store.getters.getSettings;
    this.bucketName = settings.obs_bucket_name;
    this.obs_cdn = settings.obs_cdn;
    this.obs = new ObsClient({
      access_key_id: settings.obs_key_id,
      secret_access_key: settings.obs_access_key,
      server: settings.obs_server,
      timeout: 60 * 5,
    });
  },
  methods: {
    /**
     * 文件上传之前
     */
    beforeAvatarUpload: async function (file) {
      if (this.aspectRatio && typeof this.aspectRatio == "number") {
        //如果存在要求需要剪裁
        var num = parseFloat(this.aspectRatio + "").toFixed(2);
        await new Promise((resolve) => {
          let img = new Image();
          img.onload = function () {
            file.width = img.width;
            file.height = img.height;
            resolve(file);
          };
          img.src = URL.createObjectURL(file);
        });
        var ratio = file.width / file.height;
        if (num != ratio.toFixed(2)) {
          //打开剪裁框
          this.openCropDialog(file);
          return false;
        }
      }
    },

    /**
     * 打开剪裁
     */
    openCropDialog(file) {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.cropperBase64 = reader.result;
        //显示剪裁框
        this.visibleCropper = true;
      };
    },

    /**
     * 处理剪裁
     */
    handleCropper() {
      this.$refs.cropper
        .getCroppedCanvas({
          fillColor: "#fff",
        })
        .toBlob(async (blob) => {
          let reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onload = () => {
            this.imageUrl = reader.result;
            //显示剪裁框
            this.visibleCropper = false;
            this.uploadObs(blob);
          };
        });
    },

    /**
     * 执行上传
     */
    upload(ctx) {
      let reader = new FileReader();
      reader.readAsDataURL(ctx.file);
      reader.onload = () => {
        this.imageUrl = reader.result;
        this.uploadObs(ctx.file);
      };
    },

    /**
     * 执行上传图片至obs
     */
    uploadObs: async function (file) {
      this.saving = true;

      var _f = file;
      //大于2M进行图片压缩
      if (file.size > 1024 * 1024 * 2) {
        _f = await img_utils.compress(file);
        _f.name = file.name;
      }
      //获取处理图片宽高
      await this.handlerWH(file);

      var model = {
        height: file.height,
        width: file.width,
        size: file.size,
        psd_type: 1,
        name: _f.name,
        ext: `.${_f.type.replace("image/", "")}`,
      };

      //获取md5值
      var md5 = await md5_util.fileMd5(_f);
      model.md5 = md5;

      var res = await this.$http.get(`admin/v1/common/file/dtl?md5=${md5}`);
      if (res.code == 0) {
        if (res.data) {
          this.saving = false;
          this.percentage = 100.0;
          this.$emit("change", res.data.file_url, this.hook);
          return;
        }
      }

      this.$http.get("/common/filename").then(async (res) => {
        if (res.code == 0) {
          if (!_f.name) {
            _f.name = res.data + model.ext;
            model.name = _f.name;
          }
          var result = await this.obs.putObject({
            Bucket: this.bucketName,
            Key: res.data + model.ext,
            SourceFile: _f,
            ProgressCallback: (transferredAmount, totalAmount) => {
              var percent = (transferredAmount * 100.0) / totalAmount;
              this.percentage = parseFloat(percent.toFixed(2));
            },
          });
          if (result.CommonMsg.Status < 300) {
            this.saving = false;
            this.cdn_url = `${this.obs_cdn}/${res.data}${model.ext}`;
            model.file_url = this.cdn_url;
            //存储图片到图片库
            this.$http.post("admin/v1/common/file/add", model);
            this.$emit("change", this.cdn_url, this.hook);
          }
        }
      });
    },
    /**
     * 处理图片的宽高
     */
    handlerWH(file) {
      return new Promise((resolve) => {
        let img = new Image();
        img.onload = function () {
          file.width = img.width;
          file.height = img.height;
          resolve(file);
        };
        img.src = URL.createObjectURL(file);
      });
    },
  },
};
</script>

<style scoped>
.avatar-uploader {
  position: relative;
}
.avatar-uploader .avatar {
  width: 120px;
  height: 120px;
}

.progress {
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<style>
.avatar-uploader .el-progress__text {
  color: white;
}

.avatar-uploader .el-upload {
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
  border-color: var(--el-color-primary);
}

.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  text-align: center;
}
</style>


